import { useQueryClient } from "@tanstack/react-query";
import { useAppMutation } from "../../../http/useAppMutation.ts";
import { useBoardUuid } from "./useBoardUuid.ts";

export const useUpdateContent = () => {
  const boardUuid = useBoardUuid();
  const { mutate: updateContent, isLoading } = useAppMutation({
    path: "contents/update",
    invalidate: [`boards/${boardUuid}/assets`, "inspirations/contents"],
    waitForInvalidation: false,
  }).mutation;

  const queryClient = useQueryClient();

  return {
    updateContent: ({
      contentUuid,
      isCurated,
      linkedAssetUuid,
    }: {
      contentUuid: string;
      isCurated: boolean;
      linkedAssetUuid?: string;
    }) => {
      updateContent(
        {
          uuid: contentUuid,
          is_curated: isCurated,
        },
        {
          onSuccess: () => {
            void queryClient.invalidateQueries({
              queryKey: [`contents/${contentUuid}`],
            });
            if (linkedAssetUuid) {
              void queryClient.invalidateQueries({
                queryKey: [`assets/${linkedAssetUuid}`],
              });
            }
          },
        },
      );
    },
    isUpdateContentLoading: isLoading,
  };
};
